import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_RENTAL_VEHICLE_EXCESS_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    infoRentalVehicleExcessItems: [],
  },
  errors: [],
});

const initialRentalVehicleExcess = {
  form: {
    infoRentalVehicleExcessItems: [],
  },
};

function rentalVehicleExcessSCTIStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_RENTAL_VEHICLE_EXCESS_STATE:
      return state
        .setIn(['form', 'infoRentalVehicleExcessItems'], [])
        .mergeDeep(initialRentalVehicleExcess);
    default:
      return state;
  }
}

export default rentalVehicleExcessSCTIStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.RentalVehicleExcess/reducer.js